
<div class="modal fade" id="{{copyDispatchModalId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Copy Dispatch</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="bg-primary border-bottom border-primary-subtle px-3 py-1" style="--bs-bg-opacity: .2;">
                <div class="row g-1 mb-1">
                    <div class="col-sm-4">
                        <label for="dispatchCustomer" class="form-label">{{dispatchLocationType}} Customer</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchCustomer" disabled value="{{dispatch.customerName}}" />
                    </div>
                    <div class="col-sm-5">
                        <label for="dispatchLocation" class="form-label">{{dispatchLocationType}}</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchLocation" disabled value="{{dispatch.locationName}}" />
                    </div>
                    <div class="col-sm-3">
                        <label for="dispatchLocatonCity" class="form-label">City</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchLocatonCity" disabled value="{{dispatch.locationCity}}" />
                    </div>
                </div>
                <div class="row g-1 mb-1">
                    <div class="col-sm-5">
                        <label for="dispatchTrucker" class="form-label">Trucker</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchTrucker" disabled value="{{dispatch.truckerName}}" />
                    </div>
                    <div class="col-sm-7">
                        <div class="row g-1">
                            <div class="col-4">
                                <label for="commodity" class="form-label">Commodity</label>
                                <input type="text" class="form-control form-control-sm" id="commodity" disabled value="{{dispatch.commodityCode}}" />
                            </div>
                            <div class="col-4">
                                <label for="dispatchLoads" class="form-label">Loads</label>
                                <input type="text" class="form-control form-control-sm" id="dispatchLoads" disabled value="{{dispatch.loads}}" />
                            </div>
                            <div class="col-4">
                                <label for="dispatchRate" class="form-label">Rate</label>
                                <input type="text" class="form-control form-control-sm" id="dispatchRate" disabled value="{{dispatch.rate}}" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-body" style="min-height: 400px;">
                <div class="container-fluid">
                    <form #form="ngForm">

                        <!--Schedules-->
                        <div #scheduleSearchDropdown class="border rounded p-1 mt-1 mb-3">
                            <label class="form-label">Copy to Schedule</label>
                            <div class="row g-1">
                                <div class="col-sm-3">
                                    <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="toggleScheduleSearch()">
                                        Select Schedule
                                    </button>
                                    <div *ngIf="showScheduleSearch">
                                        <div class="dropdown-search table-responsive border rounded shadow px-1">
                                            <table class="table table-sm table-borderless table-hover scrollable">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Customer
                                                            <input type="text" class="form-control form-control-sm" [(ngModel)]="scheduleSearchCustomer" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterSchedules()" />
                                                        </th>
                                                        <th>
                                                            {{scheduleLocationType}}
                                                            <input type="text" class="form-control form-control-sm" [(ngModel)]="scheduleSearchLocation" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterSchedules()" />
                                                        </th>
                                                        <th>
                                                            City
                                                            <input type="text" class="form-control form-control-sm" [(ngModel)]="scheduleSearchCity" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterSchedules()" />
                                                        </th>
                                                        <th>F/D</th>
                                                        <th>Loads</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of filteredScheduleList" (click)="selectSchedule(item)">
                                                        <td>{{item.customerName}}</td>
                                                        <td>{{item.locationName}}</td>
                                                        <td>{{item.locationCity}}</td>
                                                        <td>{{item.deliveryTerm}}</td>
                                                        <td>{{item.loads}}</td>
                                                    </tr>
                                                    <tr *ngIf="showNoSchedules">
                                                        <td colspan="5" class="text-center fs-6 pt-4">
                                                            No matching schedules were found for the selected period.
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-7">
                                    <div class="row g-1">
                                        <div class="col-5">
                                            <select name="planPeriod" class="form-select form-select-sm" (change)="planPeriodChange()" [(ngModel)]="copyDispatchParameters.planPeriod">
                                                <option *ngFor="let item of planPeriods; trackBy: trackPlanPeriod" [value]="item.value">{{item.text}}</option>
                                            </select>
                                        </div>
                                        <div class="col-7">
                                            <div class="row g-1">
                                                <div class="col-6">
                                                    <input type="date" name="planStartDate" class="form-control form-control-sm" disabled
                                                           [(ngModel)]="copyDispatchParameters.periodStartDate" [ngModelOptions]="{standalone: true}" [attr.disabled]="copyDispatchParameters.planPeriod === 'Custom' ? null: ''" />
                                                </div>
                                                <div class="col-6">
                                                    <input type="date" name="planEndDate" class="form-control form-control-sm" disabled
                                                           [(ngModel)]="copyDispatchParameters.periodEndDate" [ngModelOptions]="{standalone: true}" [attr.disabled]="copyDispatchParameters.planPeriod === 'Custom' ? null : ''" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <button type="button" class="btn btn-sm btn-primary" style="width: 80px;" (click)="searchSchedulesClick()">Search</button>
                                </div>
                            </div>

                            <div class="row g-1 mb-2">
                                <div class="col-sm-4">
                                    <label class="form-label">Customer</label>
                                    <input type="text" class="form-control form-control-sm" id="customer" name="customer" disabled value="{{schedule.customerName}}" />
                                </div>
                                <div class="col-sm-5">
                                    <label class="form-label">{{scheduleLocationType}}</label>
                                    <input type="text" class="form-control form-control-sm" id="location" name="location" disabled value="{{schedule.locationName}}" />
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label">City</label>
                                    <input type="text" class="form-control form-control-sm" id="locationCity" name="locationCity" disabled value="{{schedule.locationCity}}" />
                                </div>
                            </div>
                        </div>

                        <!--Trucker Select-->
                        <div #truckerSearchDropdown class="border rounded p-1 mb-2">
                            <div class="row g-1">
                                <div class="col-sm-2">
                                    <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="toggleTruckerSearch()">
                                        Select Trucker
                                    </button>
                                    <div *ngIf="showTruckerSearch">
                                        <div class="dropdown-search table-responsive border rounded shadow px-1">
                                            <table class="table table-sm table-borderless table-hover scrollable">
                                                <thead>
                                                    <tr [formGroup]="truckerSearchForm">
                                                        <th>
                                                            Trucker
                                                            <input type="text" class="form-control form-control-sm" formControlName="truckerName" />
                                                        </th>
                                                        <th>
                                                            City
                                                            <input type="text" class="form-control form-control-sm" formControlName="truckerCity" />
                                                        </th>
                                                        <th>
                                                            Code
                                                            <input type="text" class="form-control form-control-sm" formControlName="truckerCode" />
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of truckerList" (click)="selectTrucker(item)">
                                                        <td>{{item.customerName}}</td>
                                                        <td>{{item.city}}</td>
                                                        <td>{{item.customerCode}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <input type="text" class="form-control form-control-sm" id="trucker" placeholder="Trucker" disabled value="{{trucker.customerName}}" />
                                </div>
                                <div class="col-sm-5">
                                    <div class="row g-1">
                                        <div class="col-8">
                                            <input type="text" class="form-control form-control-sm" id="truckerCity" placeholder="City" disabled value="{{trucker.city}}" />
                                        </div>
                                        <div class="col-4">
                                            <input type="text" class="form-control form-control-sm" id="truckerCode" placeholder="Code" disabled value="{{trucker.customerCode}}" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-danger mt-4">
                            <span>{{confirmMessage}}</span>
                            <span>{{saveError}}</span>
                        </div>
                    </form>
                </div>

            </div>

            <div class="modal-footer">
                <div class="d-block w-100">
                    <div class="float-end">
                        <button type="button" class="btn btn-sm btn-primary me-2" (click)="onSaveClick()" *ngIf="formStatus == FormStatus.Normal">Copy Dispatch</button>
                        <button type="button" class="btn btn-sm btn-primary me-2" (click)="onConfirmClick()" *ngIf="formStatus == FormStatus.ConfirmSave">Confirm Copy</button>
                        <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="formStatus == FormStatus.Saving">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Saving...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Saving">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

